import { Skeleton } from "@/design-system/Skeleton/Skeleton";
import {
  RecommendedTag,
  SolutionStrategyTag,
  StrategyTag,
} from "@/design-system/Tags/SolutionTag/SolutionTag";

/* A pending row: a strategy pill and the Recommended pill, in SolutionTag's shape. */
const PENDING = (
  <>
    <Skeleton className="h-5 w-16 rounded-3xl" />
    <Skeleton className="h-5 w-24 rounded-3xl" />
  </>
);

/**
 * The strategies behind a solution, and whether it is the one we would pick.
 * The row keeps a pill's height while a solve is in flight, so the header
 * under it does not move when the tags land.
 */
export const SolutionTags = ({
  tags,
  recommended = false,
  loading = false,
}: {
  tags: SolutionStrategyTag[];
  recommended?: boolean;
  loading?: boolean;
}) => (
  <span className="flex min-h-5 flex-wrap items-center gap-1.5">
    {loading ? PENDING : tags.map((tag) => <StrategyTag key={tag} tag={tag} />)}
    {!loading && recommended && <RecommendedTag />}
  </span>
);
